export enum AssignPeoplePermissionsEnum {
  viewer = 'viewer',
  editor = 'editor',
  creator = 'creator',
}
